import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import { elementDesc } from "@/config/dataMap";
import ResultComponent from "./resultComponent";

interface calculateTask3DYCZProps {
  input: any;
  transInput: any;
  transInputs: any[]; // 每个任务对应的 input 数据
  taskDataList: any[]; // 所有任务数据
}

export default function CalculateTask3DYCZ({
  input,
  transInput,
  transInputs,
  taskDataList,
}: calculateTask3DYCZProps) {
  const [selectTreeButton, setSelectTreeButton] = useState<any>({});
  const [treeButtons, setTreeButtons] = useState<any[]>([]);
  const scrollViewRef = useRef<HTMLDivElement>(null);

  // ===================== 侧边栏逻辑：完全不变（取第一个任务） =====================
  useEffect(() => {
    const analyInputData = () => {
      if (!taskDataList.length) return;
      const firstResults = taskDataList[0].output;

      if (firstResults.elements.length) {
        const buttonList: any[] = [];
        const distilItems = input?.elements?.filter((item: any) => item.type === "DistilStrict") || [];

        distilItems.forEach((item: any) => {
                    const label = `${item.name} (${elementDesc[item.name] || ''})`;
                    buttonList.push({
                        label: label,        // 页面显示用
                        name: item.name,     // 真实设备名
                        type: item.type      // 你要的 type 
                    });
        });

        firstResults.elements.forEach((item: any) => {
          const label = `${item.name} (${elementDesc[item.name] || ""})`;
          const exist = buttonList.some(b => b.label === label);
          if (!exist) buttonList.push({ label, name: item.name, type: item.type });
        });

        setTreeButtons(buttonList);
        if (buttonList.length > 0) setSelectTreeButton(buttonList[0]);
      }
    };

    analyInputData();
  }, [taskDataList, input]);

  const renderItem1 = (item: any) => (
    <div className="tree-button-item" key={item.name}>
      <button
        onClick={() => setSelectTreeButton(item)}
        className={`tree-button ${selectTreeButton.name === item.name ? "active" : ""}`}
      >
        <span className="tree-button-text">{item.label}</span>
      </button>
    </div>
  );

  if (!taskDataList?.length || !selectTreeButton) return null;

  return (
    <div className="calculate-task-container">
      {/* 左侧：菜单逻辑完全不变 */}
      <div className="sidebar">
        <div className="sidebar-scroll">
          {treeButtons.map(renderItem1)}
        </div>
      </div>

      <div className="main-content" ref={scrollViewRef}>
        {/* 只改这里 */}
        <ResultComponent
          scrollViewRef={scrollViewRef}
          input={input}
          transInput={transInput}
          transInputs={transInputs}
          taskDataList={taskDataList}      // 传入所有任务
          selectTreeButton={selectTreeButton}
        />
      </div>
    </div>
  );
}